module.exports = __webpack_public_path__ + "img/368.e4cbdd09.jpg";